import xaxios from '@/xaxios';
import { getheadersrest } from '@/components/Utils';
import { informar } from '@/views/programa_created';
import ProgramaService from '@/views/pagos/services/programa.service';
import ProgramaUniversidadService from '@/views/pagos/services/programa-universidad.service';

export default {
  methods: {
    // ── Imágenes ──────────────────────────────────────────────────────
    imagenselect(flag) {
      if (flag == 1) { this.portadasel = !this.archivoPortada; this.subidores = false; }
      else { this.certificadosel = !this.archivoCertificado; this.subidores1 = false; }
    },

    subirimagen(flag) {
      const date = new Date().getTime();
      const formData = new FormData();
      let photo, url;
      if (flag == 1) {
        if (!this.archivoPortada) return;
        this.cargandoportada = true; this.subidores = false;
        photo = this.archivoPortada;
        formData.append('file', photo);
        formData.append('nombre', `portada-${date}.jpg`);
        url = `${process.env.VUE_APP_URL_WEBDATA}portada_upload.php`;
      } else {
        if (!this.archivoCertificado) return;
        this.cargandocertificado = true; this.subidores1 = false;
        photo = this.archivoCertificado;
        formData.append('file', photo);
        formData.append('nombre', `certificado-${date}.jpg`);
        url = `${process.env.VUE_APP_URL_WEBDATA}certificado_upload.php`;
      }
      fetch(url, { method: 'POST', headers: new Headers(), body: formData })
        .then(r => r.json())
        .then(result => {
          if (flag == 1) {
            this.cargandoportada = false;
            if (result.status) { this.subidores = true; this.programa.portada = result.newCertName; }
          } else {
            this.cargandocertificado = false;
            if (result.status) { this.subidores1 = true; this.programa.arte = result.newCertName; }
          }
        })
        .catch(() => {});
    },

    // ── Planes de cobro ───────────────────────────────────────────────
    addnewplan(flag) {
      if (!this.programa.planes) this.programa.planes = [];
      if (flag) {
        this.programa.planes.push({ aprobado: false, estado: true, nombre: '', cobros: [] });
      } else {
        const ultimo = this.programa.planes[this.programa.planes.length - 1];
        if (ultimo && !ultimo.plan_cobro_programa_id) this.programa.planes.pop();
      }
    },

    addnewconcepto(flag, plan) {
      if (flag) plan.cobros.push({ concepto_pago_id: 0, monto: 0, cuotas: 1 });
      else plan.cobros.pop();
    },

    redondearTwoDecimals(cuota, attr) {
      const incluye = (cuota[attr] + '').includes('.');
      const termina = (cuota[attr] + '').endsWith('.');
      if (incluye && !termina) cuota[attr] = Math.round((cuota[attr] + Number.EPSILON) * 100) / 100;
    },

    aprobarplan(plan) {
      let cargoid = -1;
      try { cargoid = this.$store.state.CARGO.cargo.id; } catch (e) { window.console.error(e); }
      if (cargoid != 15 && cargoid != 25 && cargoid != 1 && cargoid != 14) {
        this.$dialog.alert({ title: 'Acceso Denegado.', body: 'Usted no tiene permiso para aprobar los planes.' });
        return;
      }
      this.$dialog.confirm(
        { title: `Confirmar aprobacion del plan: ${plan.nombre}.`, body: '<b>NOTA:</b> Esta accion aprobara el plan de pagos.' },
        { verification: 'aprobar', verificationHelp: 'Escriba "[+:verification]" para aprobar.', okText: 'Aprobar plan', cancelText: 'cancelar', loader: true, type: 'hard' }
      ).then(dialog => this.aprobarplan2(dialog, plan)).catch(() => {});
    },

    aprobarplan2(dialog, plan) {
      const myHeaders = getheadersrest();
      const raw = JSON.stringify({
        programa_id: this.programa.programa_id,
        plan_cobro_id: plan.plan_cobro_programa_id,
        user_id: this.$store.state.DATA_USER.id,
      });
      fetch(`${process.env.VUE_APP_API_REST}/api/esam/programa/plan/aprobar`, { method: 'POST', headers: myHeaders, body: raw })
        .then(r => r.json())
        .then(result => {
          if (result.error) {
            this.$dialog.alert({ title: 'MENSAJE', body: result.error });
          } else {
            this.$dialog.alert({ title: 'APROBADO', body: 'El plan ha sido aprobado.' });
            plan.aprobado = true;
          }
          dialog.close();
        }).catch(() => { dialog.close(); });
    },

    // ── Postitulos ────────────────────────────────────────────────────
    addnewpostitulo(isadd) {
      if (isadd) this.postitulos.push({ id: 0, postitulo: '', programa_id: this.programa.programa_id, horas_academicas: null });
      else this.postitulos.pop();
    },

    toFindDuplicates(arry) {
      const repetidos = [];
      let repetido = false, vacio = false, sinhoras = false, demasiado = false;
      arry.forEach(x => {
        if (this.postitulouni.iduniversidad) x.universidad = this.postitulouni.iduniversidad.id;
        if (!x.postitulo) x.postitulo = '';
        if (!x.postitulo) vacio = true;
        if (!x.horas_academicas) sinhoras = true;
        else if (x.postitulo.length > 200) demasiado = true;
        if (repetidos.find(r => r == x.postitulo)) repetido = true;
        else repetidos.push(x.postitulo);
      });
      if (repetido) return 'Las certificaciones no pueden estar repetidos.';
      if (vacio) return 'Los titulos de certificaciones no pueden estar vacios.';
      if (sinhoras) return 'Las certificaciones deben estar con sus respectivas horas mayor a 0.';
      if (demasiado) return 'Los titulos de certificaciones no pueden exceder los 200 caracteres.';
      if (arry.length && !this.postitulouni.iduniversidad) return 'Seleccione la universidad de certificaciones intermedias';
      return null;
    },

    senddatapostitulos() {
      xaxios.post(`${this.api_rest}/api/v1/postitulos/asignar`, this.postitulos).catch(() => {});
    },

    // ── Código contabilidad ───────────────────────────────────────────
    guardarcodigoconta() {
      this.msg = '';
      if (!this.codigo_contabilidad) { this.msg = 'Debes ingresar un codigo de contabilidad.'; return; }
      let cargoid = -1;
      try { cargoid = this.$store.state.CARGO.cargo.id; } catch (e) { window.console.error(e); }
      if (cargoid != 15 && cargoid != 25 && cargoid != 1 && cargoid != 14) {
        this.$dialog.alert({ title: 'Acceso Denegado.', body: 'Usted no tiene permiso para guardar el codigo.' });
        return;
      }
      this.$dialog.confirm(
        { title: 'Confirmar guardado del codigo.', body: 'El codigo sera guardado, puede editarlo mas tarde' },
        { okText: 'Continuar', cancelText: 'cancelar', loader: true }
      ).then(dialog => this.guardarcodigoconta2(dialog)).catch(() => {});
    },

    guardarcodigoconta2(dialog) {
      const myHeaders = getheadersrest();
      const raw = JSON.stringify({ programa_id: this.programa.programa_id, codigo: '' + this.codigo_contabilidad });
      fetch(`${process.env.VUE_APP_API_REST}/api/esam/programa/codigo/insertar`, { method: 'POST', headers: myHeaders, body: raw })
        .then(r => r.json())
        .then(result => {
          if (result.error) this.$dialog.alert({ title: 'MENSAJE', body: result.error });
          else this.$dialog.alert({ title: 'GUARDADO', body: 'El codigo de contabilidad ha sido guardado.' });
          dialog.close();
        }).catch(() => { dialog.close(); });
    },

    // ── Sucursal ──────────────────────────────────────────────────────
    async saveFormSucursal() {
      if (this.$refs.vform.validate()) {
        if (await this.$root.$confirm.open('Guardar Sucursal', 'Estas seguro?', { color: 'red' })) {
          xaxios.post(`${this.api_rest}/api/esam/programa/sucursal/insertar`, {
            programa_id: this.programa.programa_id,
            sucursal_id: this.sucursal.id,
          }).then(() => {
            this.$root.$notify.show('Sucursal Asignado correctamente', { color: 'success' });
          });
        }
      }
    },

    // ── NetSuite ──────────────────────────────────────────────────────
    openModalNetsuiteConta() {
      if (!this.programa.planes) {
        this.$root.$notify.show('Este programa no tiene planes de cobro', { color: 'error' }); return;
      }
      const planes = [...this.programa.planes].sort((a, b) => b.cobros.length > a.cobros.length ? 1 : -1);
      const suc = this.sucursales.find(s => s.id == this.programa.sucursal_id);
      this.$refs.refNetSuiteConta.open(planes[0], this.programa, suc, this.yaenviado);
    },

    // ── Proyecto UNSXX ────────────────────────────────────────────────
    asignarprogramaunsxx(proy) { this.proyectosxx = proy; },

    asignarprogramaunsxx2(idprograma) {
      this.loading = true;
      xaxios.post(`${process.env.VUE_APP_API_REST}/api/v1/programa-unsxx/asignarproyecto`, {
        id_programa: idprograma, id_proyecto: this.proyectosxx.id,
      }).then(() => {
        this.msg = `Programa registrado exitosamente (${idprograma}), proyecto asignado: ${this.proyectosxx.text}`;
        this.loading = false;
      }).catch(() => {
        this.msg = `Programa registrado exitosamente (${idprograma}), no se pudo asignar el proyecto`;
        this.loading = false;
      });
    },

    // ── Guardar programa principal ────────────────────────────────────
    guardarcambios() {
      let date1 = new Date(this.programa.fecha_matricula + 'T00:00:00-04:00');
      let date2 = new Date(this.programa.fecha_inicio + 'T00:00:00-04:00');
      if (date2.getTime() - date1.getTime() < 0) {
        this.msg = 'La fecha de matriculacion debe ser menor a la fecha de inicio del programa.'; return;
      }
      this.msg = '';
      // const obj = { ...this.programa };
      const obj = JSON.parse(JSON.stringify(this.programa))
      if (!obj.sede_id) { this.msg = 'Seleccione la sede'; return; }

      const unidad_negocio_id = this.UNIDAD_NEGOCIO_ID;
      if (unidad_negocio_id == 1 || unidad_negocio_id == 10) {
        if (!this.universidadsel || !this.universidadsel.id) {
          this.msg = 'Debe seleccionar la universidad/institucion de certificacion.'; return;
        }
      }
      if (this.modulos_obligatorios && obj.programa_modulo.length == 0) {
        this.msg = 'Esta categoria de postgrado requiere los modulos obligatoriamente.'; return;
      }
      if (this.modulos_obligatorios) {
        if ((this.programa.xcategoria_id == 1 || this.programa.xcategoria_id == 24) && obj.programa_modulo.length < 5) {
          this.msg = 'Registre todos los modulos del programa, el diplomado debe tener al menos 5 modulos'; return;
        }
        if ((this.programa.xcategoria_id == 2 || this.programa.xcategoria_id == 25) && obj.programa_modulo.length < 7) {
          this.msg = 'Registre todos los modulos del programa, la Especialidad debe tener al menos 7 modulos'; return;
        }
        if ((this.programa.xcategoria_id == 3 || this.programa.xcategoria_id == 26) && obj.programa_modulo.length < 10) {
          this.msg = 'Registre todos los modulos del programa, la Maestría debe tener al menos 10 modulos'; return;
        }
      }
      if (!this.programa.modalidad) { this.msg = 'Seleccione la modalidad'; return; }
      if (this.isdevmode && !obj.portada) obj.portada = 'sinfotoentest.jpg';
      if (!obj.portada) { this.msg = 'Seleccione y suba la portada'; return; }
      if (!obj.nombre_corto) { this.msg = 'Ingrese el nombre corto del programa'; return; }
      if (obj.nombre_corto.length > 60) { this.msg = 'El nombre corto no puede ser mayor a 60 caracteres'; return; }
      if (!obj.fecha_matricula) { this.msg = 'Debe ingresar la fecha de matriculacion del programa'; return; }

      if (this.sucursal) obj.sucursal_id = this.sucursal.id;

      this.loading = true;
      let valido = true;
      if (!obj.planes) obj.planes = [];

      // Convertir fechas a dd/mm/yyyy
      const formatFecha = (f) => { if (!f) return f; const s = f.split('-'); return `${s[2]}/${s[1]}/${s[0]}`; };
      obj.fecha_matricula = formatFecha(obj.fecha_matricula);
      obj.fecha_inicio = formatFecha(obj.fecha_inicio);
      obj.fecha_fin = formatFecha(obj.fecha_fin);

      if (!obj.nombre_compuesto.endsWith(')')) {
        const uni = this.universidadsel ? `U${this.universidadsel.id}` : 'U';
        obj.nombre_compuesto += ` (V${obj.version} G${obj.grupo} ${obj.gestion} S${obj.sede_id} ${uni})`;
      }

      obj.programa_modulo = obj.programa_modulo.map(m =>
        m.programa_modulo_id < 0 ? { ...m, programa_modulo_id: null } : m
      );

      const newplanes = [], oldplanes = [];
      obj.planes.forEach(e => {
        if (!e.plan_cobro_programa_id) {
          newplanes.push(e);
          e.cobros.forEach(c => {
            if (c.concepto_pago_id == 1 && c.monto > 1500) { valido = false; this.loading = false; this.msg = 'La matricula no puede exceder el monto de 1500 bs.'; }
            if (!c.monto || c.monto < 0) { valido = false; this.loading = false; this.msg = `Monto (${c.monto}) invalido en ${e.nombre}`; }
            if (c.xmax_cuotas && c.xmax_cuotas < c.cuotas) { valido = false; this.loading = false; this.msg = `Cuotas (${c.cuotas}) supera el maximo ${c.xmax_cuotas}`; }
          });
        } else {
          e.cobros.forEach(c => {
            c.concepto_pago_id = c.concepto_id;
            delete c.cobro_programa_id; delete c.fecha_registro; delete c.estado;
          });
          oldplanes.push(e);
        }
      });
      if (!valido) return;

      const dupError = this.toFindDuplicates(this.postitulos);
      if (dupError) { this.msg = dupError; return; }

      if (unidad_negocio_id == 1 && !this.universidadsel.id) { this.msg = 'Seleccione la universidad de convenio'; return; }

      const addmodulos = [], modmodulos = [];
      if (obj.programa_modulo) {
        obj.programa_modulo.forEach(e => {
          const formatM = (f) => { if (f && f.includes('-')) { const s = f.split('-'); return `${s[2]}/${s[1]}/${s[0]}`; } return undefined; };
          e.fecha_inicio = formatM(e.fecha_inicio);
          e.fecha_fin = formatM(e.fecha_fin);
          if (e.docente) e.docente_id = e.docente.docente_id;
          delete e.nombre; delete e.estado; delete e.puntuacion;
          delete e.fecha_primera_instancia; delete e.fecha_segunda_instancia;
          e.programa_modulo_id = e.programa_modulo_id < 0 ? null : e.programa_modulo_id;
          const modulo = { ...e, numero: Number(e.numero) || 0 };
          delete modulo.xmodulo;
          delete e.xmodulo;
          if (e.programa_modulo_id) modmodulos.push(modulo);
          else addmodulos.push(modulo);
        });
      }

      obj.modificar_planes = oldplanes;
      obj.modulos = addmodulos;
      obj.modificar_modulos = modmodulos;
      delete obj.planes;
      obj.planes = newplanes;
      if (obj.programa_id) delete obj.programa_modulo;
      if (!obj.arte) delete obj.arte;
      if (!obj.fecha_matricula) delete obj.fecha_matricula;
      if (!obj.fecha_inicio) delete obj.fecha_inicio;
      if (!obj.fecha_fin) delete obj.fecha_fin;
      if (!obj.universidad_id) delete obj.universidad_id;
      if (!obj.plataforma_id) delete obj.plataforma_id;
      if (!obj.coordinador.coordinador_id) delete obj.coordinador;
      if (!obj.responsable.responsable_id) delete obj.responsable;
      if (this.coordinadorsel.idusuario) obj.coordinador = { coordinador_id: this.coordinadorsel.idusuario.id };
      if (this.responsablesel.idusuario) obj.responsable = { responsable_id: this.responsablesel.idusuario.id };
      if (this.universidadsel && this.universidadsel.id) obj.universidad_id = this.universidadsel.id;
      else obj.universidad_id = null;

      const metodo = obj.programa_id ? 'PUT' : 'POST';

      this.$dialog.confirm(
        { title: 'Confirmacion.', body: 'Si no esta seguro puede cancelar' },
        { okText: 'Continuar', cancelText: 'cancelar', loader: true }
      ).then(dialog => {
        this.senddatapostitulos();
        this.senddatoscreateupdate(dialog, obj, metodo);
      }).catch(() => { this.loading = false; });
    },

    senddatoscreateupdate(dialog, obj, metodo) {
      dialog.close();
      const myHeaders = getheadersrest();
      fetch(`${this.api_rest}/esam/programa`, { method: metodo, headers: myHeaders, body: JSON.stringify(obj) })
        .then(r => r.json())
        .then(result => {
          if (typeof result == 'string') {
            this.msg = result;
          } else if (result.data) {
            this.msg = result.data;
          } else if (result.programa_id) {
            if (this.proyectosxx) {
              this.msg = `Programa creado (${result.programa_id}), asignando proyecto...`;
              this.asignarprogramaunsxx2(result.programa_id);
            } else {
              this.msg = `Programa registrado exitosamente, ID: ${result.programa_id}`;
              if (metodo == 'POST') this.rerportTG(obj.portada, obj.nombre_compuesto, result.programa_id);
            }
          } else {
            this.msg = result.error;
          }
          this.loading = false;
        })
        .catch(() => { this.loading = false; });
    },

    rerportTG(portada_url, name, programa_id) {
      const base = 'https://api.telegram.org/bot5407981377:AAF42Y3skFV9YsCXMpXLJ7eVwCjHopQSJ2E/sendPhoto?';
      const chat_id = '-1001783499111';
      const image = this.location_programa_portadas + portada_url;
      const url = `${base}chat_id=${chat_id}&photo=${image}&caption=Nuevo Programa: <b>${name}</b>&parse_mode=HTML`;
      fetch(url).then(r => r.json());
      const u = this.$store.state.CARGO.sede.unidad_negocio;
      if (u != 4) informar(image, name, u, programa_id);
    },

    // ── Programa-Universidad (servicio separado) ──────────────────────
    async obtenerProgramasUniversidades() {
      try {
        const { data } = await ProgramaUniversidadService.findAllPorUniversidadIdBusqueda({
          params: { universidadId: this.programaSeleccionado?.universidadId, busqueda: this.busqueda || null },
        });
        this.programasUniversidades = data?.datos || [];
      } catch (error) {
        this.programasUniversidades = [];
        this.$notify({ group: 'notifications', title: 'Error', text: error?.response?.data?.mensaje || 'Error al listar', type: 'error' });
      }
    },

    async obtenerPrograma(programaId) {
      try {
        const { data } = await ProgramaService.findOne(programaId);
        this.programaSeleccionado = data.datos;
      } catch (error) {
        this.programaSeleccionado = { universidadId: null, programaUniversidadId: null, programaUniversidad: null };
        this.$notify({ group: 'notifications', title: 'Error', text: error?.response?.data?.mensaje || 'Error al listar', type: 'error' });
      }
    },

    async actualizarPrograma() {
      if (!this.programaSeleccionado) return;
      this.actualizandoPrograma = true;
      try {
        const { data } = await ProgramaService.update(this.programaSeleccionado.id, {
          programaUniversidadId: this.programaSeleccionado.programaUniversidadId,
        });
        this.$refs.confirmacionRef.cerrar();
        this.obtenerPrograma(this.programaSeleccionado.id);
        this.visibleDialogo = false;
        this.$notify({ group: 'notifications', title: 'Éxito', text: data?.mensaje || 'Programa actualizado', type: 'success' });
      } catch (error) {
        this.$notify({ group: 'notifications', title: 'Error', text: error?.response?.data?.mensaje || 'Error al actualizar', type: 'error' });
      } finally {
        this.actualizandoPrograma = false;
      }
    },

    mostrarDialogo() {
      if (this.programaSeleccionado) {
        this.programaSeleccionado.universidadId = this.programaSeleccionado.programaUniversidad
          ? this.programaSeleccionado.programaUniversidad.sedeUniversidad?.universidadId
          : this.programaSeleccionado?.universidadId;
        this.obtenerProgramasUniversidades().then(() => { this.visibleDialogo = true; });
      }
    },

    cambiarUniversidad() {
      this.programaSeleccionado = { universidadId: null, programaUniversidadId: null, programaUniversidad: null };
      this.obtenerProgramasUniversidades();
    },

    busquedaProgramaUniversidad(search, loading) {
      clearTimeout(this.retardo);
      this.busqueda = search;
      this.retardo = setTimeout(() => {
        loading(true);
        this.obtenerProgramasUniversidades().finally(() => loading(false));
      }, 500);
    },

    cerrarDialogo() {
      this.obtenerPrograma(this.programaSeleccionado.id);
      this.visibleDialogo = false;
    },
  },
};
